module.exports = __webpack_public_path__ + "img/c_11.6381f293.png";